// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"5f6494712f6d4d33","5971":"fc1a284868b17ea3"}[chunkId] + ".css";
};